<template>
  <Drawer
    width="800"
    v-model="drawerOpened"
    :title="currentSalesCost.customer ? currentSalesCost.customer.name : ''"
  >
    <div class="drawer-wrap">
      <div class="drawer-contetn">
        <div class="basic-info">
          <div class="copy-button">
            <Button
              long
              :disabled="currentSalesCost.calcSalesCost ? false : true"
              class="btn"
              :data-clipboard-text="con"
              @click="copy(currentSalesCost)"
            >
              复制数据
            </Button>
          </div>
          <div class="basicInfo-item">
            <div>销售简称</div>
            <div class="basicInfo-item-data">
              {{ currentSalesCost.abbr ? currentSalesCost.abbr : "" }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>材料名称</div>
            <div class="basicInfo-item-data">
              #{{
                currentSalesCost.material
                  ? currentSalesCost.material.model
                  : ""
              }}-
              {{
                currentSalesCost.material ? currentSalesCost.material.name : ""
              }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>配方名称</div>
            <div class="basicInfo-item-data">
              #{{
                currentSalesCost.prodRecipe
                  ? currentSalesCost.prodRecipe.NoId
                  : ""
              }}
              {{
                currentSalesCost.prodRecipe
                  ? currentSalesCost.prodRecipe.name
                  : ""
              }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>核算日期</div>
            <div class="basicInfo-item-data">
              {{ currentSalesCost.createdAt }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>生产工厂</div>
            <div class="basicInfo-item-data">
              {{
                currentSalesCost.factory ? currentSalesCost.factory.name : ""
              }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>材料成本</div>
            <div class="basicInfo-item-data">
              {{ adjustNumber(currentSalesCost, "calcSalesCost.materialCost") }}
            </div>
          </div>

          <div class="basicInfo-item">
            <div>运费</div>
            <div class="basicInfo-item-data">
              {{ adjustNumber(currentSalesCost, "calcSalesCost.transCost") }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>业务费</div>
            <div class="basicInfo-item-data">
              {{ adjustNumber(currentSalesCost, "calcSalesCost.promoFee") }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>复配费</div>
            <div class="basicInfo-item-data">
              {{ adjustNumber(currentSalesCost, "calcSalesCost.manufactCost") }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>税费</div>
            <div class="basicInfo-item-data">
              {{ adjustNumber(currentSalesCost, "calcSalesCost.tax") }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>合计成本</div>
            <div class="basicInfo-item-data">
              {{ adjustNumber(currentSalesCost, "calcSalesCost.totalCost") }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>售价</div>
            <div class="basicInfo-item-data">
              {{ adjustNumber(currentSalesCost, "calcSalesCost.price") }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>利润</div>
            <div class="basicInfo-item-data">
              {{ adjustNumber(currentSalesCost, "calcSalesCost.profit") }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>利润率</div>
            <div class="basicInfo-item-data">
              {{
                adjustNumber(currentSalesCost, "calcSalesCost.profitRate", "%")
              }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>账期（月）</div>
            <div class="basicInfo-item-data">
              {{ adjustNumber(currentSalesCost, "calcSalesCost.estAging") }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>资金成本</div>
            <div class="basicInfo-item-data">
              {{ adjustNumber(currentSalesCost, "calcSalesCost.agingCost") }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>合计成本(含资)</div>
            <div class="basicInfo-item-data">
              {{
                adjustNumber(
                  currentSalesCost,
                  "calcSalesCost.totalCostWithAging"
                )
              }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>利润(含资)</div>
            <div class="basicInfo-item-data">
              {{
                adjustNumber(currentSalesCost, "calcSalesCost.profitAfterAging")
              }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>利润率(含资)</div>
            <div class="basicInfo-item-data">
              {{
                adjustNumber(
                  currentSalesCost,
                  "calcSalesCost.profitRateAfterAging",
                  "%"
                )
              }}
            </div>
          </div>
          <div class="basicInfo-item">
            <div>年收益率</div>
            <div class="basicInfo-item-data">
              {{
                adjustNumber(
                  currentSalesCost,
                  "calcSalesCost.annualizedRateOfReturns",
                  "%"
                )
              }}
            </div>
          </div>
        </div>
        <div class="material-table">
          <Table
            border
            :loading="tableLoading"
            :columns="columns"
            :data="prodRecipe.materialCostDetail"
          >
          </Table>
        </div>
      </div>
    </div>
  </Drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";
import Clipboard from "clipboard";
import customer from "@/store/modules/customer";

export default {
  name: "CalcSalesDetailDrawer",
  data() {
    return {
      drawerOpened: false,
      currentSalesCost: {},
      tableLoading: false,
      prodRecipe: {},
      columns: [
        {
          title: "材料",
          key: "material",
          align: "left",
          width: 160,
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  fontSize: 16,
                },
              },
              params.row.material.model
                ? params.row.material.model
                : params.row.material.name
            );
          },
        },
        {
          title: "比例",
          key: "ratio",
          align: "right",
          width: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.ratio ? (params.row.ratio * 100).toFixed(2) + "%" : ""
            );
          },
        },
        {
          title: "单价",
          key: "calcUnitCost",
          align: "right",
          render: (h, params) => {
            return h(
              "div",
              params.row.calcUnitCost ? parseInt(params.row.calcUnitCost) : ""
            );
          },
        },
        {
          title: "价格",
          key: "materialCost",
          align: "right",
          render: (h, params) => {
            return h("div", parseInt(params.row.materialCost));
          },
        },
      ],
      con: null,
    };
  },
  methods: {
    ...mapActions({
      getCalcSalesCostByID: "caclSalesCost/getCalcSalesCostByIDAction",
    }),
    adjustNumber(params, numberString, appendString) {
      const value = _.get(params, numberString, "");
      if (typeof value === "number") {
        return appendString
          ? (value * 100).toFixed(2) + appendString
          : value.toFixed(0);
      } else if (typeof value === "string") {
        return "";
      }
    },
    async openDrawer(salesCost) {
      this.currentSalesCost = {};
      this.prodRecipe = {};
      this.drawerOpened = true;
      const data = salesCost;
      data.createdAt = dayjs(data.calcSalesCost.createdAt).format("YYYY-MM-DD HH:mm");
      this.currentSalesCost = data;
      if (salesCost.prodRecipe) {
        try {
          const recipe = await this.getCalcSalesCostByID(
            salesCost.calcSalesCost._id
          );

          const data = recipe;
          const total = {
            material: {},
            materialCost: null,
            calcUnitCost: null,
          };
          total.material.name = "材料合计";
          total.materialCost = recipe.materialCost;
          total.ratio = data.materialCostDetail.reduce((p, c) => {
            return p + c.ratio;
          }, 0);
          data.materialCostDetail.push(total);
          this.prodRecipe = data;
        } catch (error) {
          return this.$Message.error("获取成本核算错误");
        }
      }
    },
    // 要copy的数据进行处理
    copy(salesCost) {
      this.con = `${salesCost.customer.name}${salesCost.material.model}
销售简称：${salesCost.abbr}
配方编号：#${salesCost.prodRecipe.NoId} ${salesCost.prodRecipe.name}
配方日期：${dayjs(salesCost.prodRecipe.createdAt).format("YYYY-MM-DD HH:mm")}
核算日期：${salesCost.createdAt}
工厂：${salesCost.factory.name}
材料成本：${this.adjustNumber(salesCost, "calcSalesCost.materialCost")}
运输费：${this.adjustNumber(salesCost, "calcSalesCost.transCost")}
业务费：${this.adjustNumber(salesCost, "calcSalesCost.promoFee")}
复配费：${this.adjustNumber(salesCost, "calcSalesCost.manufactCost")}
税费：${this.adjustNumber(salesCost, "calcSalesCost.tax")}
合计成本：${this.adjustNumber(salesCost, "calcSalesCost.totalCost")}
售价：${this.adjustNumber(salesCost, "calcSalesCost.price")}
利润：${this.adjustNumber(salesCost, "calcSalesCost.profit")}
利润率：${this.adjustNumber(salesCost, "calcSalesCost.profitRate", "%")}
账期(月)：${this.adjustNumber(salesCost, "calcSalesCost.estAging")}
资金成本：${this.adjustNumber(salesCost, "calcSalesCost.agingCost")}
合计成本(含资)：${this.adjustNumber(
        salesCost,
        "calcSalesCost.totalCostWithAging"
      )}
利润(含资)：${this.adjustNumber(salesCost, "calcSalesCost.profitAfterAging")}
利润率(含资)：${this.adjustNumber(
        salesCost,
        "calcSalesCost.profitRateAfterAging",
        "%"
      )}
ARR: ${this.adjustNumber(
        salesCost,
        "calcSalesCost.annualizedRateOfReturns",
        "%"
      )}
本数据为成本预估，不作为最终确认的核算数据`;
      this.copyMethod();
    },
    // 调用copy的方法
    copyMethod() {
      let clipboard = new Clipboard(".btn");
      clipboard.on("success", (e) => {
        this.$Message.success("已复制到剪切板");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.drawer-wrap
  padding 20px
  font-size 16px

.drawer-contetn
  display flex

.copy-button
  display flex
  justify-content flex-end
  margin-bottom 8px

.basic-info
  padding 0 20px 0 20px
  margin-bottom 20px
  width 300px

.basicInfo-item:nth-child(even)
  background-color #f7f7f7

.material-table
  width 440px

.basicInfo-item
  display flex
  justify-content space-between
  padding 2px 8px
  border-bottom 1px solid #e9e9e9

  .basicInfo-item-data
    text-align right
</style>